export default [
  {
    path: "/qmyx",
    name: "qmyx_layout",
    component: () => import("./layout.vue"),
    children: [
      {
        path: "agent-auth",
        name: "agent-auth",
        meta: {
          title: "经纪人认证"
        },
        component: () => import("./agent-auth/index.vue")
      },
      {
        path: "check-agent",
        name: "check-agent",
        meta: {
          title: ""
        },
        component: () => import("./check-agent/index.vue")
      },
      {
        path: "certification",
        name: "certification",
        meta: {
          title: "实名认证"
        },
        component: () => import("./certification/index.vue")
      },
      {
        path: "client-backup",
        name: "client-backup",
        meta: {
          title: "客户报备"
        },
        component: () => import("./client-backup/index.vue")
      },
      {
        path: "backup-result",
        name: "backup-result",
        meta: {
          title: "报备完成"
        },
        component: () => import("./client-backup/result.vue")
      },
      {
        path: "choose-building",
        name: "choose-building",
        meta: {
          title: "客户报备-选择楼盘"
        },
        component: () => import("./choose-building/index.vue")
      },
      {
        path: "agent2",
        name: "agent2",
        meta: {
          title: "身份变更"
        },
        component: () => import("./agent2/index.vue")
      },
      {
        path: "user-agreement",
        name: "user-agreement",
        meta: {
          title: "用户注册协议"
        },
        component: () => import("./user-agreement")
      },
      {
        path: "advisor-select",
        name: "advisor-select",
        meta: {
          title: "选择顾问"
        },
        component: () => import("./advisor-select/index.vue")
      },
      {
        path: "my-customer",
        name: "my-customer",
        meta: {
          title: "我的客户"
        },
        component: () => import("./my-customer/index.vue")
      },
      {
        path: "my-customer-detail",
        name: "my-customer-detail",
        meta: {
          title: "客户详情"
        },
        component: () => import("./my-customer/detail.vue")
      },
      {
        path: "invite-client-recommend-customers",
        name: "invite-client-recommend-customers",
        meta: {
          title: "发展经纪人推荐客户查询"
        },
        component: () => import("./invite-client-recommend-customers/index.vue")
      },
      {
        path: "invite-client-recommend-customers-detail",
        name: "invite-client-recommend-customers-detail",
        meta: {
          title: "发展经纪人推荐客户详情"
        },
        component: () =>
          import("./invite-client-recommend-customers/detail.vue")
      },
      {
        path: "invite-client",
        name: "invite-client",
        meta: {
          title: "发展经纪人"
        },
        component: () => import("./invite-client")
      },
      {
        path: "cash-back",
        name: "cash-back",
        meta: {
          title: "佣金"
        },
        component: () => import("./cash-back")
      },
      {
        path: "my-score",
        name: "my-score",
        meta: {
          title: "我的积分"
        },
        component: () => import("./my-score")
      },
      {
        path: "inviter-detail",
        name: "inviter-detail",
        meta: {
          title: "发展经纪人"
        },
        component: () => import("./invite-client/inviter-detail")
      },
      {
        path: "score-rule",
        name: "score-rule",
        meta: {
          title: "积分规则"
        },
        component: () => import("./my-score/score-rule")
      },
      {
        path: "exchange-records",
        name: "exchange-records",
        meta: {
          title: "兑换记录"
        },
        component: () => import("./my-score/exchange-records")
      },
      {
        path: "exchange-succeed",
        name: "exchange-succeed",
        meta: {
          title: "兑换记录"
        },
        component: () => import("./my-score/exchange-succeed")
      },
      {
        path: "score-exchange",
        name: "score-exchange",
        meta: {
          title: "积分兑换"
        },
        component: () => import("./my-score/score-exchange")
      }
    ]
  }
];
